import AnimatedLoader from '../../../components/AnimatedLoader';
import '../../../styles/containers/SavingsCalculator/savingsCalculator.scss';

// import faiths from '../../../constants/PrayerFaithsConstants';
import React from 'react'
import {useEffect, useState} from 'react'
import useMoengage from '../../../hooks/useMoengage';
import NextButton from './NextButton';
import '../../../styles/containers/SavingsCalculator/components/next-button.scss';
import axios from 'axios';

import {Routes} from '../../../constants/RouterConstants';
import { Navigation } from '../../../services/NavigationService';
import NavigationSection from './NavigationSection';
import SavingsCalculatorConstants from '../../../constants/SavingsCalculatorConstants'
import SavingsCard from './SavingsCard';
import ThankYouPage from './ThankYouPage';
import { experimentalStyled as styled } from '@mui/material/styles';
import { useHistory, useLocation } from 'react-router-dom';
import RoutingService from '../../../services/RoutingService';
import groupSmall from '../../../assets/groupSmall.png';
import groupMedium from '../../../assets/groupMedium.png';
import groupLarge from '../../../assets/groupLarge.png';
import cashSmall from '../../../assets/cashSmall.png';
import cashLarge from '../../../assets/cashLarge.png';
import cashMedium from '../../../assets/cashMedium.png';
import cashSavingAmount from '../../../assets/cashSavingAmount.png';
import savingAmountTV from '../../../assets/savingAmountTV.png';
import savingAmountBike from '../../../assets/savingAmountBike.png';
import savingAmountFridge from '../../../assets/savingAmountFridge.png';
import savingAmountPhone from '../../../assets/savingAmountPhone.png';


function SavingsAmount() {
  const [userId, setUserId] = useState('');
  const [savingsAmount, setSavingsAmount] = useState('');
  const [firstAmount, setFirstAmount] = useState('');
  const [secondAmount, setSecondAmount] = useState('');
  const [thirdAmount, setThirdAmount] = useState('');


  const history = useHistory();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [notify, setNotify] = useState(null);
  const [isPayroll, setIsPayroll] = useState(false);
  const isWebview=window.navigator.userAgent.includes ('wv');
  const trackEvent = useMoengage()[1];
  async function fetchUserPayrollOrNotInfo(endPoint, query) {
    var config = {
        method: 'get',
        url: `${process.env.REACT_APP_API_HOST}/v2/app/${endPoint}?${query}`,
        headers: { 
          'Content-Type': 'application/json',
          'Access-Control-Allow-Credentials':'true',
          'Access-Control-Allow-Methods':'GET,HEAD,OPTIONS,POST,PUT',
          'Access-Control-Allow-Headers':'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
          "Cache-Control": null,
          "X-Requested-With": null  
        },
    };
      
    return axios(config).then((response) => {
        if(response.status === 200) {
            return response.data;
        } else {
          throw new Error('Server Error');
        }
    })
}
  useEffect(() => {
      const paramString = window.location.href.split('?')[1];
      const queryString = new URLSearchParams(paramString);
      let userIdParam,savingsAmountParam;
      queryString.forEach((value, key) => {
        if (key === 'userId') userIdParam = value;
        if(key === 'savingsAmount')savingsAmountParam=value;
      });
      if (!userIdParam) return;
      else if(!savingsAmountParam)return;
      else if (!location.amount) history.replace(`/savingsCalculator/earnings?userId=${userIdParam}`);
      else {
          if(savingsAmountParam === '500'){
            setFirstAmount('5 months');
            setSecondAmount('2 years');
            setThirdAmount('11 years');
          }
          else if(savingsAmountParam==='1000'){
            setFirstAmount('10 weeks');
            setSecondAmount('11 months');
            setThirdAmount('4 years');
          }
          else if(savingsAmountParam==='2000'){
            setFirstAmount('5 weeks');
            setSecondAmount('6 months');
            setThirdAmount('2 years 11 months');        }
        else if(savingsAmountParam==='5000'){
            setFirstAmount('2 weeks');
            setSecondAmount('9 weeks');
            setThirdAmount('1 year 5 months');        }
          console.log(userIdParam,savingsAmountParam);
          setUserId(userIdParam);
          setSavingsAmount(savingsAmountParam);
          fetchUserPayrollOrNotInfo('checkPayrolluserOrNot', `userId=${userIdParam}`)
            .then((userData) => {
                setIsPayroll(userData.isPayrollUser);
            })
            .catch(e => {
                console.log(e.toString());
            })
          setIsLoading(false);
      };
  },[])

  const handleNextButtonClick = function () {
    //   Navigation.push({pathname: Routes.SAVINGS_AMOUNT, search:`userId=${userId}&savingsAmount=${selectedSavings.substring(1)}`});
      trackEvent('savings_interested');
      console.log(isWebview,isPayroll);
      if(isWebview == true && isPayroll == true){
          //https://mitra.vahan.co/payroll/view-earnings
          window.location.href = `https://mitra.vahan.co/payroll/view-earnings`;
      }
      setNotify(true);
  }

  return isLoading ? (
    <AnimatedLoader containerStyle={{ height: '100vh' }} />
  ) : ((notify? (
    <ThankYouPage/>
  ):(<div className='__main-container' style={{ minHeight: '100vh' }}>
    <NavigationSection path={`${Routes.SELECT_SAVINGS}`} search={`userId=${userId}`} reload={true} />
    <div className='__horizontal-center select-faith-heading' style={{
      marginTop:'8%',
    }}>With <span style={{
              color: '#C69A00'
          }}>₹{savingsAmount}/week</span> you can save a lot 👇</div>
          <div className="container-fluid" style={{ marginTop: '8%' }}>
              <div style={{
              }}>
                  <p style={{
                      position: 'absolute',
                      width: '64px',
                      height: '18px',
                      left: '78px',
                      top: '220px',
                      fontFamily: 'Open Sans',
                      fontStyle: 'normal',
                      fontWeight: 'bold',
                      fontSize: '12px',
                      lineHeight: '150%',
                      textAlign: 'center',
                      textTransform: 'uppercase',
                      color: '#C69A00',
                  }}>{firstAmount}</p>
                  <span>
                      <img
                          src={groupSmall}
                          alt="companyName"
                      />
                  </span>
                  <span>
                      <img
                          src={cashSmall}
                          alt="companyName"
                          style={{ marginLeft: '-2%' }}
                      />
                  </span>
                  <span style={{
                      position: 'absolute',
                      width: '69px',
                      height: '27px',
                      left: '220px',
                      top: '220px',
                      fontFamily: 'Open Sans',
                      fontStyle: 'normal',
                      fontWeight: '800',
                      fontSize: '18px',
                      lineHeight: '150%',
                      textAlign: 'right',
                      color: '#111111',
                      marginLeft:'-5%',
                  }}>
        ₹10,000
        </span>
    </div>
    

    <div style={{
                  marginTop:'5%',
              }}>
                  <p style={{
                      position: 'absolute',
                      width: '80px',
                      height: '18px',
                      left: '101px',
                      top: '287px',
                      fontFamily: 'Open Sans',
                      fontStyle: 'normal',
                      fontWeight: 'bold',
                      fontSize: '12px',
                      lineHeight: '150%',
                      textAlign: 'center',
                      textTransform: 'uppercase',
                      color: '#C69A00',
                  }}>{secondAmount}</p>
                  <span>
                      <img
                          src={groupMedium}
                          alt="companyName"
                          style={{}}
                      />
                  </span>
                  <span>
                      <img
                          src={cashMedium}
                          alt="companyName"
                          style={{ marginLeft: '-2%' }}
                      />
                  </span>
                  <span style={{
                      position: 'absolute',
                      width: '69px',
                      height: '27px',
                      left: '253px',
                      top: '287px',
                      fontFamily: 'Open Sans',
                      fontStyle: 'normal',
                      fontWeight: '800',
                      fontSize: '18px',
                      lineHeight: '150%',
                      textAlign: 'right',
                      color: '#111111',
                  }}>
        ₹50,000
        </span>
    </div>
    


    <div style={{
                  marginTop:'5%',
              }}>
                  <p style={{
                      position: 'absolute',
                      width: '130px',
                      height: '18px',
                      left: '110px',
                      top: '362px',
                      fontFamily: 'Open Sans',
                      fontStyle: 'normal',
                      fontWeight: 'bold',
                      fontSize: '12px',
                      lineHeight: '150%',
                      textAlign: 'center',
                      textTransform: 'uppercase',
                      color: '#C69A00',
                  }}>{thirdAmount}</p>
                  <span>
                      <img
                          src={groupLarge}
                          alt="companyName"
                          style={{}}
                      />
                  </span>
                  <span>
                      <img
                          src={cashLarge}
                          alt="companyName"
                          style={{ marginLeft: '-2%' }}
                      />
                  </span>
                  <span style={{
                      position: 'absolute',
                      width: '97px',
                      height: '30px',
                      left: '248px',
                      top: '403px',
                      fontFamily: 'Open Sans',
                      fontStyle: 'normal',
                      fontWeight: '800',
                      fontSize: '20px',
                      lineHeight: '150%',
                      textAlign: 'right',
                      color: '#111111',
                  }}>
        ₹3 Lakh
        </span>
    </div>

                  <div style={{
                      display: "flex",
                     flexWrap: 'wrap',
                     flexDirection:'row',
                      marginTop: '15%',
                      width: '100%',
                      height: '44px',
                      background: ' rgba(198, 154, 0, 0.1)',
                      position:'relative',
                  }}>
                  <div style={{
                      width: '30px',
                      height: '17.37px',
                      top: '460px',
                      left:'21px',
                      margin:'8px',
                  }}>
                      <img
                          src={cashSavingAmount}
                          alt="companyName"
                      />
                  </div>
                  <div style={{
                      width: '129px',
                      height: '21px',
                      left: '59px',
                      fontFamily: 'Open Sans',
                      fontStyle: 'normal',
                      fontWeight: 'bold',
                      fontSize: '14px',
                      lineHeight: '150%',
                      textAlign: 'center',
                      textTransform: 'uppercase',
                      color: '#333333',
                      marginLeft:'5px',
                      marginTop:'11px',

                  }}>
                  Savings amount
                  </div>
                    
                  <div style={{
                      width: '116px',
                      height: '27px',
                      fontFamily: 'Open Sans',
                      fontStyle: 'normal',
                      fontWeight: '800',
                      fontSize: '18px',
                      lineHeight: '150%',
                      textAlign: 'center',
                      textTransform: 'uppercase',
                      color: '#C69A00',
                      marginLeft:'20px',
                      marginTop:'8px',

                  }}>
                  ₹{savingsAmount}/week
                  </div>

        </div>

        </div>
       

        <div className="container-fluid" style={{ 
            marginTop: '8%' ,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            }}>

                <span>
                <img
                          src={savingAmountBike}
                          alt="companyName"
                      />
                </span>

              <span>
                  <img
                      src={savingAmountPhone}
                      alt="companyName"
                      width="24px"
                      height="27px"
                  />
              </span>
              <span style={{
                  width: '97px',
                  height: '78px',
                  left: '240px',
                  top: '506px',
              }}>
                  <img
                      src={savingAmountTV}
                      alt="companyName"

                      />
              </span>
              <span style={{
                  width: '103px',
                  height: '103px',
                  left: '248px',
                  top: '473px',
              }}>
                <img
                          src={savingAmountFridge}
                          alt="companyName"
                      />
                  </span>
              </div>

              

        <div className="container-fluid" style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        }}>

        <button className='next-button-container' onClick={handleNextButtonClick}>
            Notify Me
        </button>

        </div>

    </div>
    )))
}

export default SavingsAmount





//earning.value== selectedEarning ?'3px solid #C69A00'
//earning.value== selectedEarning ?'#C69A00'